<p>
  {{message | translate}}
</p>